import React from 'react';
import { Route, Switch } from 'react-router';

import Login from '../Components/Login';
import Register from '../Components/Register';
import PilotRegister from '../Components/PilotRegister';
import Dashboard from '../Components/Dashboard';
import Password from '../Components/Password';

import Diary from '../Components/Dashboard/Pages/Diary';
import Task from '../Components/Dashboard/Pages/Task';
import Note from '../Components/Dashboard/Pages/Note';
import Plan from '../Components/Dashboard/Pages/Plan';
import Sorry from '../Components/Register/FormPages/Sorry';
import ResetPassword from '../Components/Dashboard/Pages/ResetPassword';
import ForgotPassword from '../Components/Dashboard/Pages/ForgotPassword';
import Assessment from '../Components/Assessment';

const routes = (
  <div className="dashboard">
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/password" component={Password} />
      <Route exact path="/dashboard" component={Dashboard} />
      <Route exact path="/dashboard/diary" component={Diary} />
      <Route exact path="/dashboard/note" component={Note} />
      <Route exact path="/dashboard/task" component={Task} />
      <Route exact path="/dashboard/plan" component={Plan} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/DCH-pilot" component={PilotRegister} />
      <Route exact path="/sorry" component={Sorry} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/assessment" component={Assessment} />
    </Switch>
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/Routes/index.jsx